import { useState, useEffect } from 'react';
import styles from "../../../styles/igsosaAdminAuth.module.css";
import AdminDashboard from './AdminDashboard';

const AdminAuthIgsosa = () => {
    const [isAuthenticated, setIsAuthenticated] = useState(() => {
        try { return sessionStorage.getItem('adminAuth') === 'true'; } catch (e) { return false; }
    });
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const ADMIN_PASSWORD = 'igsosaadminmanagement';

    // Check if user is already authenticated on component mount
useEffect(() => {
    const auth = sessionStorage.getItem('adminAuth');
    const authTime = sessionStorage.getItem('adminAuthTime');

    if (auth === 'true' && authTime) {
        const elapsedTime = Date.now() - parseInt(authTime);
        const expiry = 48 * 60 * 60 * 1000;

        if (elapsedTime < expiry) {
            setIsAuthenticated(true);
        } else {
            sessionStorage.clear();
        }
    }
}, []);

    const handleSubmit = (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');

        // Simulate auth delay
        setTimeout(() => {
            if (password === ADMIN_PASSWORD) {
                // Store auth token in session storage
                sessionStorage.setItem('adminAuth', 'true');
                sessionStorage.setItem('adminAuthTime', new Date().getTime());
                setPassword('');
                setIsAuthenticated(true);
            } else {
                setError('Invalid password. Please try again.');
                setPassword('');
            }
            setLoading(false);
        }, 500);
    };

    const handleLogout = () => {
        sessionStorage.removeItem('adminAuth');
        sessionStorage.removeItem('adminAuthTime');
        setIsAuthenticated(false);
        setPassword('');
        setError('');
    };

    // Show admin dashboard if authenticated

      if (isAuthenticated) return <AdminDashboard onLogout={handleLogout} />;

    // Show auth form if not authenticated
    return (
        <div className={styles.authcontainer}>
            <div className={styles.authbox}>
                <div className={styles.authheader}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" fill="currentColor" viewBox="0 0 16 16">
                        <path d="M8 1a2 2 0 0 1 2 2v4H6V3a2 2 0 0 1 2-2zm3 6V3a3 3 0 0 0-6 0v4a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2z"/>
                    </svg>
                    <h1>Admin Access</h1>
                </div>
                
                <p className={styles.subtitle}>Enter password to access admin panel</p>

                <form onSubmit={handleSubmit} className={styles.form}>
                    <div className={styles.formgroup}>
                        <label htmlFor="password">Password</label>
                        <input
                            id="password"
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            placeholder="Enter admin password"
                            className={styles.input}
                            disabled={loading}
                            autoFocus
                        />
                    </div>

                    {error && <div className={styles.error}>{error}</div>}

                    <button 
                        type="submit" 
                        className={styles.submitbtn}
                        disabled={loading}
                    >
                        {loading ? 'Verifying...' : 'Login'}
                    </button>
                </form>

                <div className={styles.footer}>
                    <p className={styles.security}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" viewBox="0 0 16 16">
                            <path d="M10.854 7.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7.5 9.793l2.646-2.647a.5.5 0 0 1 .708 0z"/>
                            <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                        </svg>
                        Secure connection
                    </p>
                </div>
            </div>
        </div>
    );
};

export default AdminAuthIgsosa;
